import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function IdliPlatter() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Idli Platter
          </h1>
          <p
            style={{
              fontSize: "1.2rem",
              color: "#555",
              marginBottom: 16,
              textAlign: "center",
              maxWidth: 700,
            }}
          >
            Two delicious idli variations on one plate - spicy Masala Idli and cheesy Pizza Idli!
          </p>
          <span className="season-badge season-winter" style={{ marginBottom: 24 }}>❄️ Best in Winter</span>
          <ImageWithFallback
            src="/idli_platter.png"
            alt="Idli Platter"
            className="recipe-image-anim"
            style={{
              width: 600,
              height: 400,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            {/* Masala Idli Section */}
            <div style={{ marginBottom: 48 }}>
              <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 24, color: "#d9534f" }}>
                Masala Idli
              </h2>
              
              <h3 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
                Ingredients:
              </h3>
              <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
                <li>3-4 idlis</li>
                <li>1 tbsp oil or ghee</li>
                <li>1/2 tsp mustard seeds</li>
                <li>1/2 tsp cumin seeds</li>
                <li>5-6 curry leaves</li>
                <li>1 green chili, slit</li>
                <li>1 large onion, finely chopped</li>
                <li>1 tomato, finely chopped</li>
                <li>1/4 tsp turmeric powder</li>
                <li>1/2 tsp red chili powder</li>
                <li>1/2 tsp coriander powder</li>
                <li>1/4 tsp garam masala</li>
                <li>Salt to taste</li>
                <li>Fresh coriander leaves for garnish</li>
                <li>Lemon juice</li>
              </ul>

              <h3 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
                Instructions:
              </h3>
              <ol className="instructions-list" style={{ paddingLeft: 20, marginBottom: 24 }}>
                <li style={{ marginBottom: 12 }}>
                  Cut idlis into bite-sized cubes.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Heat oil in a pan, add mustard seeds and let them splutter. Add cumin seeds, curry leaves, and green chili.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Add chopped onions and sauté until golden brown.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Add tomatoes and cook until soft.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Add turmeric, red chili powder, coriander powder, garam masala, and salt. Mix well.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Add idli pieces and gently toss to coat with masala. Cook for 2-3 minutes.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Add lemon juice and garnish with fresh coriander. Serve hot!
                </li>
              </ol>
            </div>

            {/* Pizza Idli Section */}
            <div style={{ marginBottom: 32 }}>
              <h2 style={{ fontSize: "2rem", fontWeight: 600, marginBottom: 24, color: "#5cb85c" }}>
                Pizza Idli
              </h2>
              
              <h3 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
                Ingredients:
              </h3>
              <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
                <li>3-4 idlis</li>
                <li>1/2 cup pizza sauce or tomato ketchup</li>
                <li>1 cup mozzarella cheese, grated</li>
                <li>1/2 onion, finely chopped</li>
                <li>1/2 capsicum (bell pepper), finely chopped</li>
                <li>1 tomato, finely chopped</li>
                <li>1/4 cup corn kernels (optional)</li>
                <li>2-3 mushrooms, sliced (optional)</li>
                <li>1/2 tsp oregano</li>
                <li>1/2 tsp chili flakes</li>
                <li>Salt and pepper to taste</li>
                <li>Fresh basil or coriander for garnish</li>
              </ul>

              <h3 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
                Instructions:
              </h3>
              <ol className="instructions-list" style={{ paddingLeft: 20, marginBottom: 24 }}>
                <li style={{ marginBottom: 12 }}>
                  Preheat oven to 180°C (350°F) or heat a pan with a lid.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Cut idlis in half horizontally to create flat surfaces.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Spread pizza sauce or ketchup on top of each idli half.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Top with chopped onions, capsicum, tomatoes, corn, and mushrooms.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Sprinkle generously with grated mozzarella cheese.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Add oregano, chili flakes, salt, and pepper.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Bake in oven for 8-10 minutes or cover pan and cook on low heat until cheese melts.
                </li>
                <li style={{ marginBottom: 12 }}>
                  Garnish with fresh herbs and serve hot!
                </li>
              </ol>
            </div>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Day-old idlis work best as they are firmer and easier to handle</li>
                <li>For masala idli, don't over-stir to prevent breaking</li>
                <li>For pizza idli, you can use an air fryer at 180°C for 5-7 minutes</li>
                <li>Customize toppings based on your preference</li>
                <li>Both variations can be made ahead and reheated</li>
                <li>Serve with coconut chutney, mint chutney, or ketchup</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Idlis are steamed, not fried, making them naturally low in fat and easy to digest.</li>
                <li>Fermented rice and lentil batter provides B vitamins and gut-friendly probiotics.</li>
                <li>Adding vegetables to the masala idli boosts fiber, vitamins, and minerals.</li>
                <li>A satisfying breakfast or snack that's gentle on the stomach, even for kids.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default IdliPlatter;